const isLocal = window.location.host.includes('localhost');
export const FAST_TRACK_URL = isLocal
  ? `${window.location.protocol}//${window.location.host.split(':')[0]}:5000/ft`
  : `${window.location.protocol}//${window.location.host}/ft`;

// API
const API_ENDPOINT_PREFIX = '/api';
const API_V2_ENDPOINT_PREFIX = `${API_ENDPOINT_PREFIX}/v2`;

// CONFIG
export const API_CONFIG_ENDPOINT = `${API_ENDPOINT_PREFIX}/v2/config`;

// TENANT MANAGEMENT
export const TENANT_MANAGEMENT_ENDPOINT = `${API_ENDPOINT_PREFIX}/tenant-management`;
export const TENANT_MANAGEMENT_CURRENT_ENDPOINT = `${TENANT_MANAGEMENT_ENDPOINT}/current`;
export const TENANT_MANAGEMENT_LIST_ENDPOINT = `${TENANT_MANAGEMENT_ENDPOINT}/list`;
export const TENANT_MANAGEMENT_CREATE_ENDPOINT = `${API_ENDPOINT_PREFIX}/v2/utility/tenant/create`;
export const TENANT_MANAGEMENT_CHANGE_ENDPOINT = (id) =>
  `${TENANT_MANAGEMENT_ENDPOINT}/change/${id}`;
export const TENANT_MANAGEMENT_DELETE_ENDPOINT = (id) =>
  `${TENANT_MANAGEMENT_ENDPOINT}/delete/${id}`;

// SETTINGS
export const SETTINGS_ENDPOINT = `${API_ENDPOINT_PREFIX}/settings`;
export const SETTINGS_INDEX_SYNC_ENDPOINT = `${SETTINGS_ENDPOINT}/syncIndexes`;

// CONTRACTS
export const CONTRACTS_ENDPOINT = `${API_ENDPOINT_PREFIX}/contracts/`;
export const CONTRACTS_V2_ENDPOINT = `${API_V2_ENDPOINT_PREFIX}/mongo/contracts`;
export const CONTRACTS_COUNT_ENDPOINT = `${API_ENDPOINT_PREFIX}/contracts/count`;
export const CONTRACT_DELETE_ENDPOINT = `${API_ENDPOINT_PREFIX}/contract/`;
export const CONTRACT_COMPARE_ENDPOINT = `${CONTRACTS_ENDPOINT}compare`;
export const CONTRACT_ISCHECKED_ENDPOINT = `${API_ENDPOINT_PREFIX}/contract/updateChecked`;
export const CONTRACT_SLOTS_ENDPOINT = `${API_ENDPOINT_PREFIX}/contract/updateSlots`;
export const CONTRACT_ISPLUGIN_UNREVIEWED_ENDPOINT = `${API_ENDPOINT_PREFIX}/contract/updateIsPluginUnreviewed`;

const DD_API_BASE_URI = isLocal
  ? `${window.location.protocol}//${window.location.host.split(':')[0]}:5001`
  : `${window.location.protocol}//${window.location.host}`;
const DD_API_ENDPOINT_PREFIX = `${DD_API_BASE_URI}/rd/api`;
export const CONTRACTS_LIST_ENDPOINT = `${DD_API_ENDPOINT_PREFIX}/contracts`;
export const REPORT_LIST_ENDPOINT = `${DD_API_ENDPOINT_PREFIX}/reportList`;
export const REPORT_ENDPOINT = `${DD_API_ENDPOINT_PREFIX}/report`;
export const MIGRATE_REPORT_ENDPOINT = `${DD_API_ENDPOINT_PREFIX}/migrateReport`;
export const USER_EDITS_REPORT_ENDPOINT = `${DD_API_ENDPOINT_PREFIX}/user-edits-report`;
export const WEBSOCKET_API_BASE_URI = isLocal
  ? `ws://${window.location.host.split(':')[0]}:5001/rd/api`
  : `wss://${window.location.host}/rd/api`;

// GLOBAL EVENTS WEB SOCKET
export const GLOBAL_EVENT_WEB_SOCKET_ENDPOINT = '/global/event';

// CONTRACTS WEB SOCKET
export const CONTRACTS_WEB_SOCKET_ENDPOINT = '/contracts';

// LOGS WEB SOCKET
export const LOGS_WEB_SOCKET_ENDPOINT = '/logs';

// LOGS WEB SOCKET
export const TRAINING_JOBS_WEB_SOCKET_ENDPOINT = '/jobs/training';

// EVENTLOGS
export const EVENTLOGS_ENDPOINT = `${API_ENDPOINT_PREFIX}/eventlogs`;
export const EVENTLOGS_LOG_NAMES_ENDPOINT = `${API_ENDPOINT_PREFIX}/eventlogs/lognames`;
export const EVENTLOGS_REPORT_NAMES_ENDPOINT = `${API_ENDPOINT_PREFIX}/eventlogs/reportnames`;

// CLEARINGHOUSE
export const CLEARINGHOUSE_ENDPOINT = `${API_ENDPOINT_PREFIX}/clearinghouse/`;
export const CLEARINGHOUSE_DOCUMENTS_ENDPOINT = `${CLEARINGHOUSE_ENDPOINT}documents`;
export const CLEARINGHOUSE_IMPORT_ASYNC_ENDPOINT = `${API_V2_ENDPOINT_PREFIX}/utility/clearinghouse/import`;

// ASYNC JOBS
export const ASYNC_JOBS_ENDPOINT = `${API_V2_ENDPOINT_PREFIX}/async-jobs`;
export const ASYNC_JOB_BY_ID_ENDPOINT = (jobId) => `${ASYNC_JOBS_ENDPOINT}/${jobId}`;

// FILES
export const FILES_ENDPOINT = `${API_ENDPOINT_PREFIX}/files/`;

// IMAGES
export const IMAGES_ENDPOINT = `${API_ENDPOINT_PREFIX}/images`;

// RESOURCE DOWNLOADS
export const RESOURCES_ENDPOINT_PREFIX = `${API_ENDPOINT_PREFIX}`;
export const USERGUIDE_ENDPOINT = `${RESOURCES_ENDPOINT_PREFIX}/userguide`;

// SUGGESTIONS
export const SUGGESTIONS_ENDPOINT = `${API_ENDPOINT_PREFIX}/suggestions`;

// COMPARISONS
export const COMPARISONS_ENDPOINT = `${API_ENDPOINT_PREFIX}/comparisons`;

// USERS
export const USERS_ENDPOINT = `${API_ENDPOINT_PREFIX}/users`;
export const USER_ACCOUNT_RESET_PASSWORD = `${USERS_ENDPOINT}/reset-password`;
export const USER_RESEND_WELCOME_EMAIL = `${USERS_ENDPOINT}/resend-welcome-email`;
export const USER_INFO_TRACK_ENDPOINT = `${API_ENDPOINT_PREFIX}/user/info/track`;
export const CURRENT_USER_ENDPOINT = `${API_ENDPOINT_PREFIX}/current-user`;
export const USER_NEW_ENDPOINT = `${API_ENDPOINT_PREFIX}/users/add-user`;
export const USER_UPDATE_ENDPOINT = `${API_ENDPOINT_PREFIX}/users/update-user`;

// USERS EMAILS
export const USER_EMAILS_ENDPOINT = `${API_ENDPOINT_PREFIX}/user-emails/`;

// ACCOUNT GROUPS
export const ACCOUNT_GROUPS_ENDPOINT = `${API_ENDPOINT_PREFIX}/account-groups/`;

// USER SETTINGS
export const USER_SETTINGS_ENDPOINT = `${API_ENDPOINT_PREFIX}/users/settings`;

// GROUPS
export const GROUPS_ENDPOINT = `${API_ENDPOINT_PREFIX}/groups`;
export const GROUPS_ASSIGNED_ENDPOINT = `${API_ENDPOINT_PREFIX}/groups/assigned`;
export const GROUPS_CLEANUP_ENDPOINT = `${GROUPS_ENDPOINT}/cleanup`;

// ACCESS PROFILES
export const ACCESS_PROFILES_ENDPOINT = `${API_ENDPOINT_PREFIX}/access-profiles`;

// MODELS
export const MODELS_ENDPOINT = `${API_ENDPOINT_PREFIX}/trainingmodels`;
export const MODELS_V2_ENDPOINT = `${API_V2_ENDPOINT_PREFIX}/mongo/training-model`;
export const MODELS_RULES_ENDPOINT = (id) =>
  `${API_ENDPOINT_PREFIX}/trainingmodels/${id}/rules`;
export const MODELS_ALL_FILTERED_ENDPOINT = `${API_ENDPOINT_PREFIX}/trainingmodels-all-filtered`;
export const MODELS_ALL_ENDPOINT = `${API_ENDPOINT_PREFIX}/trainingmodels-all`;
export const MODELS_FILE_ENDPOINT = `${API_V2_ENDPOINT_PREFIX}/utility/playbook/import`;
export const MODELS_BASICS_ENDPOINT = (id) => `${MODELS_ENDPOINT}/${id}/basics`;
export const MODELS_COUNT_TRAINING_ENDPOINT = (id) =>
  `${MODELS_ENDPOINT}/${id}/count-training`;
export const MODELS_UNASSIGNED_TRAINING_ENDPOINT = (id) =>
  `${MODELS_ENDPOINT}/${id}/unassigned/training`;
export const MODELS_DOWNLOAD_WEB_SOCKET_ENDPOINT = '/trainingmodels/download'; // NOTE: No /api prefix here
export const MODELS_DOWNLOAD_TSV_WEB_SOCKET_ENDPOINT = '/trainingmodels/download-tsv'; // NOTE: No /api prefix here
export const MODELS_DOWNLOAD_TSV_FILE_ENDPOINT = (id) =>
  `${MODELS_ENDPOINT}/${id}/download-tsv-file`;
export const MODELS_MIGRATE_ENDPOINT = (id) => `${MODELS_ENDPOINT}/${id}/migrate-to-v2`;
export const MODELS_BY_QUESTIONNAIRE = `${MODELS_ENDPOINT}/by-questionnaire`;

// QUESTIONS
export const QUESTIONS_ENDPOINT = `${API_ENDPOINT_PREFIX}/questions`;

// LLM / AI SERVICES
export const LLM_ENDPOINT = `${API_ENDPOINT_PREFIX}/llm`;
export const LLM_GENERATE_REGEX_ENDPOINT = `${LLM_ENDPOINT}/generate/regex`;
export const LLM_GENERATE_RULE_NAME_DESCRIPTION_ENDPOINT = `${LLM_ENDPOINT}/generate/rule-name-description`;

// INTEGRATIONS
export const INTEGRATIONS_ENDPOINT = `${API_ENDPOINT_PREFIX}/integrations`;
export const INTEGRATION_AUTHORIZE_ENDPOINT = `${INTEGRATIONS_ENDPOINT}/authorize`;
export const INTEGRATION_AUTH_ENDPOINT = `${INTEGRATIONS_ENDPOINT}/auth`;
export const INTEGRATION_AUTH_TOKEN_ENDPOINT = `${INTEGRATION_AUTH_ENDPOINT}/token`;
export const INTEGRATION_AUTH_REFRESH_ENDPOINT = `${INTEGRATION_AUTH_ENDPOINT}/refresh`;
export const INTEGRATION_AUTH_UPDATE_ENDPOINT = `${INTEGRATIONS_ENDPOINT}/update`;
export const INTEGRATION_DELETE_ENDPOINT = (id) => `${INTEGRATIONS_ENDPOINT}/${id}`;
export const INTEGRATION_SUBSCRIBE_ENDPOINT = (id) =>
  `${INTEGRATIONS_ENDPOINT}/${id}/subscribe`;
export const INTEGRATION_SUBSCRIPTIONS_ENDPOINT = (id) =>
  `${INTEGRATIONS_ENDPOINT}/${id}/subscriptions`;
export const INTEGRATION_DELETE_SUBSCRIPTION_ENDPOINT = (id, subscriptionId) =>
  `${INTEGRATIONS_ENDPOINT}/${id}/subscription/${subscriptionId}`;
export const INTEGRATION_REGISTER_ENDPOINT = `${INTEGRATIONS_ENDPOINT}/register`;

// QUESTIONNAIRES
export const QUESTIONNAIRES_ENDPOINT = `${API_ENDPOINT_PREFIX}/questionnaires`;
export const QUESTIONNAIRES_DEFAULT_ENDPOINT = `${API_ENDPOINT_PREFIX}/questionnaires/default`;
export const QUESTIONNAIRES_LIST_ENDPOINT = `${API_ENDPOINT_PREFIX}/questionnaires/list`;
export const QUESTIONNAIRES_MOVE_ENDPOINT = (id) =>
  `${QUESTIONNAIRES_ENDPOINT}/${id}/move`;
export const QUESTIONNAIRES_ADD_SECTION_ENDPOINT = (id) =>
  `${QUESTIONNAIRES_ENDPOINT}/${id}/add-section`;

// TRAINING
const TRAINING_ENDPOINT = `${API_ENDPOINT_PREFIX}/training`;
export const TRAINING_MODIFY_EDITS_ENDPOINT = `${TRAINING_ENDPOINT}/modifyEdits`;
export const TRAINING_DELETE_BY_IDS_ENDPOINT = `${TRAINING_ENDPOINT}/deleteByIds`;
export const TRAINING_CREATE_FROM_ZIP_ENDPOINT = `${TRAINING_ENDPOINT}/create/fromZip`;
export const TRAINING_ATTRIBUTES_ENDPOINT = `${TRAINING_ENDPOINT}/attributes`;
export const TRAINING_PREVIEW_ENDPOINT = `${TRAINING_ENDPOINT}/preview`;

// JOBS
const JOBS_ENDPOINT = `${API_ENDPOINT_PREFIX}/jobs`;

// TRAINING JOBS
export const TRAINING_JOBS_GET_ENDPOINT = `${JOBS_ENDPOINT}/training`;

// TRAINING RULES
export const TRAINING_RULES_ENDPOINT = `${API_ENDPOINT_PREFIX}/training/rules`;
export const TRAINING_RULES_LEAF_LIST_EDIT_ENDPOINT = `${TRAINING_RULES_ENDPOINT}/leafListEdit`;
export const TRAINING_RULES_POINT_EDIT_ENDPOINT = `${TRAINING_RULES_ENDPOINT}/pointEdit`;
export const TRAINING_RULES_SUB_EDIT_ENDPOINT = `${TRAINING_RULES_ENDPOINT}/subEdit`;
export const TRAINING_RULES_FXI_ENDPOINT = `${TRAINING_RULES_ENDPOINT}/fxi`;
export const TRAINING_RULES_GOVERNING_LAW_ENDPOINT = `${TRAINING_RULES_ENDPOINT}/governingLawEdit`;
export const TRAINING_RULES_FORUM_ENDPOINT = `${TRAINING_RULES_ENDPOINT}/forumEdit`;
export const TRAINING_RULES_TERM_ENDPOINT = `${TRAINING_RULES_ENDPOINT}/termEdit`;
export const TRAINING_RULES_IMPORT_RULES_ENDPOINT = `${API_V2_ENDPOINT_PREFIX}/utility/playbook/copy-rules`;
export const TRAINING_RULES_ANSWER_QUESTIONS_ENDPOINT = `${API_V2_ENDPOINT_PREFIX}/utility/playbook/onboard`;
export const TRAINING_RULE_DISABLE_ENDPOINT = `${TRAINING_RULES_ENDPOINT}/disable`; // Added new endpoint
export const TRAINING_RULE_PROMPT_ENDPOINT = `${TRAINING_RULES_ENDPOINT}/prompt`; // Added endpoint for updating prompts
export const TRAINING_RULES_REMOVE_SENTENCES_ENDPOINT = `${TRAINING_RULES_ENDPOINT}/removeSentences`; // Added endpoint for removing sentences from rule

// TRAINING RULE SECTIONS
export const TRAINING_RULE_SECTIONS_ENDPOINT = `${API_ENDPOINT_PREFIX}/training/rule/sections`;

// TEXT
export const TEXT_ENDPOINT = `${API_ENDPOINT_PREFIX}/text`;

// COMPANIES
export const COMPANIES_ENDPOINT = `${API_ENDPOINT_PREFIX}/companies`;

// ONLY OFFICE
export const ONLYOFFICE_CONFIG_ENDPOINT = `${API_ENDPOINT_PREFIX}/onlyoffice/config`;
export const ONLYOFFICE_TRACK_ENDPOINT = `${API_ENDPOINT_PREFIX}/onlyoffice/track`;

// ONLY OFFICE PLUGIN
export const ONLYOFFICE_PLUGIN_ENDPOINT = `${API_ENDPOINT_PREFIX}/plugin`;

// CLAUSES
export const CLAUSES_ENDPOINT = `${API_ENDPOINT_PREFIX}/clauses`;
export const CLAUSES_DELETE_ENDPOINT = `${API_ENDPOINT_PREFIX}/clauses/`;
export const CLAUSE_CATEGORIES_ENDPOINT = `${API_ENDPOINT_PREFIX}/clause-categories`;

// METRICS
export const METRICS_ENDPOINT = `${API_ENDPOINT_PREFIX}/metrics`;

// EVENTS
export const EVENTS_ENDPOINT = `${API_ENDPOINT_PREFIX}/events`;
export const EVENTS_RECENT_WORK_ENDPOINT = `${API_ENDPOINT_PREFIX}/events/recentwork`;
export const EVENTS_BLACKBOILER_ENDPOINT = `${API_ENDPOINT_PREFIX}/events/analytics`;
export const EVENTS_FASTTRACK_ENDPOINT = `${API_ENDPOINT_PREFIX}/events/fasttrack`;
export const EVENTS_DOCUSIGN_ENDPOINT = `${EVENTS_FASTTRACK_ENDPOINT}/docusign`;

// FAST TRACK
export const FAST_TRACK_ENDPOINT = `${API_ENDPOINT_PREFIX}/fasttrack`;
export const FAST_TRACK_FORMFILL_ENDPOINT = `${FAST_TRACK_URL}/formfill`;
export const FAST_TRACK_SIGNING_ENDPOINT = `${FAST_TRACK_URL}/ds`;
export const FAST_TRACK_POA_ENDPOINT = `${FAST_TRACK_URL}/poa`;
export const FAST_TRACK_POA_RENEWAL_ENDPOINT = `${FAST_TRACK_URL}/poa_renewal`;
export const FAST_TRACK_POA_LIST_ENDPOINT = `${FAST_TRACK_POA_ENDPOINT}/list`;
export const FAST_TRACK_POA_PENDING_APPROVAL_ENDPOINT = `${FAST_TRACK_POA_ENDPOINT}/approvalrequests`;
export const FAST_TRACK_POA_DOC_ENDPOINT = `${FAST_TRACK_POA_ENDPOINT}/doc`;
export const FAST_TRACK_POA_HELP_ENDPOINT = `${FAST_TRACK_POA_ENDPOINT}/help`;
export const FAST_TRACK_POA_DOWNLOAD_ENDPOINT = `${FAST_TRACK_POA_ENDPOINT}/download`;
export const FAST_TRACK_POA_ATTACHMENT_DOWNLOAD_ENDPOINT = (
  submissionId,
  attachmentName
) => `${FAST_TRACK_POA_ENDPOINT}/attachment/${submissionId}/${attachmentName}`;
export const FAST_TRACK_POA_UPLOADGEMS_ENDPOINT = `${FAST_TRACK_POA_ENDPOINT}/gems`;
export const FAST_TRACK_POA_ACTIVEPOA_ENDPOINT = `${FAST_TRACK_POA_ENDPOINT}/active`;
export const FAST_TRACK_POA_RESPONSIBILITIES_ENDPOINT = `${FAST_TRACK_POA_ENDPOINT}/responsibilities`;
export const FAST_TRACK_POA_NOTIFY_ENDPOINT = `${FAST_TRACK_POA_ENDPOINT}/notify`;

// POA GEMS
export const FAST_TRACK_POA_GEMS_ENDPOINT = `${API_ENDPOINT_PREFIX}/poa-gems`;

// POA V2
export const POA_V2_ENDPOINT = `${API_V2_ENDPOINT_PREFIX}/utility/poa`;

// MIGRATION
export const MIGRATION_ENDPOINT = `${API_ENDPOINT_PREFIX}/account-migration`;
export const ROUTING_MIGRATION_ENDPOINT = `${API_ENDPOINT_PREFIX}/routing-migration`;

// LOGGING
export const LOG_ENDPOINT = `${API_ENDPOINT_PREFIX}/logging/log`;
export const LOG_LOGIN_ENDPOINT = `${API_ENDPOINT_PREFIX}/logging/login`;
export const LOG_LOGOUT_ENDPOINT = `${API_ENDPOINT_PREFIX}/logging/logout`;

// /BBWEB PREFIXED FOR PLUGIN
const BB_WEB_PREFIX = '/bbweb';
export const BBWEB_PREFIXED_CONTRACTS_ENDPOINT = `${BB_WEB_PREFIX}${CONTRACTS_ENDPOINT}`;

// FIND SIMILAR
export const FIND_SIMILAR_ENDPOINT = `${API_ENDPOINT_PREFIX}/similarity`;
export const FIND_SIMILAR_GENERAL_ENDPOINT = `${FIND_SIMILAR_ENDPOINT}/general`;
export const FIND_SIMILAR_PRESENCE_ENDPOINT = `${FIND_SIMILAR_ENDPOINT}/presence`;
export const FIND_SIMILAR_CONTEXT_ENDPOINT = `${FIND_SIMILAR_ENDPOINT}/context`;
export const FIND_SIMILAR_EDIT_ENDPOINT = `${FIND_SIMILAR_ENDPOINT}/edit`;
export const FIND_SIMILAR_SEMANTIC_ENDPOINT = `${FIND_SIMILAR_ENDPOINT}/semantic`;

// ACCOUNT
export const ACCOUNT_ENDPOINT = `${API_ENDPOINT_PREFIX}/account`;
// NOTE: Deactivate changing tier type for a while
// export const ACCOUNT_TIER_CHANGE_ENDPOINT = `${ACCOUNT_ENDPOINT}/tier-change`;
export const ACCOUNT_UPDATE_UPLOADED_CONTRACTS_ENDPOINT = `${ACCOUNT_ENDPOINT}/update-uploaded-contracts`;

// TIER COMPARISON
export const TIER_COMPARISONS_ENDPOINT = `${API_ENDPOINT_PREFIX}/tier-comparisons`;

// WEBHOOKS
const WEBHOOK_ENDPOINT = `${API_ENDPOINT_PREFIX}/webhook`;
export const WEBHOOK_EXPORT_CONTRACT_ENDPOINT = (id) =>
  `${WEBHOOK_ENDPOINT}/export-contract/${id}`;

// DISTRIBUTED TRACING
export const ERROR_REPORTING_ENDPOINT = `${API_ENDPOINT_PREFIX}/trace/error`;
export const LOG_REPORTING_ENDPOINT = `${API_ENDPOINT_PREFIX}/trace/log`;

// GEO
export const FETCH_GEO = `${API_ENDPOINT_PREFIX}/geo/fetch`;
